












































































import Vue from 'vue';
import GiftStatus from '@/web/components/gift/GiftStatus.vue';
import GiftPurchasesDetailsModal from '@/web/components/gift/GiftPurchasesDetailsModal.vue';
import EditGiftPurchaseModal from '@/web/components/gift/EditGiftPurchaseModal.vue';
import sales from '@/core/api/modules/sales';

interface LocalState {
  search: string;
  status: string;
  date: DatePicker;
  tableFields: PaginatedTableField[];
}

export default Vue.extend({
  name: 'GiftPurchases',
  components: {
    GiftStatus,
  },
  props: {
    currency: {
      type: String,
      required: true,
    },
    api: {
      type: String,
      required: true,
    },
    productId: {
      type: Number,
      default: undefined,
    },
  },
  data(): LocalState {
    return {
      search: '',
      status: undefined,
      date: {},
      tableFields: [
        {
          title: this.$t('GIFTS.LABELS.RECIPIENT') as string,
          name: 'recipient',
          cssClass: 'h5 m-0',
        },
        {
          title: this.$t('GIFTS.LABELS.PURCHASER') as string,
          name: 'purchaser',
          cssClass: 'h5 m-0',
        },
        {
          name: 'product',
          title: this.$t('GIFTS.LABELS.PRODUCT') as string,
          cssClass: 'h5 m-0',
          key: 'product_name',
        },
        {
          name: 'status',
          title: this.$t('GIFTS.LABELS.STATUS') as string,
          cssClass: 'h5 m-0',
        },
        {
          name: 'purchased',
          title: this.$t('GIFTS.LABELS.PURCHASED') as string,
          cssClass: 'h5 m-0',
        },
        {
          name: 'amount',
          title: this.$t('GIFTS.LABELS.AMOUNT') as string,
          cssClass: 'h5 m-0',
        },
        {
          name: 'edit',
          shrink: true,
          cssClass: 'p-0',
          disableClick: true,
        },
      ],
      statusesOptions: [
        {
          label: this.$t('GIFTS.LABELS.UNCLAIMED'),
          code: 'unclaimed',
        },
        {
          label: this.$t('GIFTS.LABELS.SCHEDULED'),
          code: 'scheduled',
        },
        {
          label: this.$t('GIFTS.LABELS.CLAIMED'),
          code: 'claimed',
        },
      ],
    };
  },
  computed: {
    query(): {} {
      return {
        q: this.search,
        startDate: this.date?.startDate,
        endDate: this.date?.endDate,
        status: this.status?.code,
        id: this.productId,
      };
    },
  },
  methods: {
    viewDetails(giftPurchase) {
      this.$modal.show(
        GiftPurchasesDetailsModal,
        { giftPurchase, currency: this.currency },
        {},
        {
          edit: () => this.editGiftPurchase(giftPurchase),
          resend: () => this.resend(giftPurchase.id),
        }
      );
    },
    editGiftPurchase(giftPurchase) {
      this.$modal.show(
        EditGiftPurchaseModal,
        { giftPurchase },
        {},
        {
          finish: this.refreshTable,
        }
      );
    },
    refreshTable() {
      this.$refs.giftsPurchasesTable?.refresh();
    },
    async resend(id) {
      try {
        await sales.resendGiftEmail(id);
        await this.refreshTable();
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
        });
      } catch (error) {
        this.inProgress = false;
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t('GENERAL.ERROR.GIFT_EMAIL_RESEND_FAILED'),
          duration: -1, // stay ON
        });
        return;
      }
    },
    async toggleGiftActive(data) {
      try {
        await sales.updateGiftPurchase(data.id, { active: !data.active });
        await this.refreshTable();
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
        });
      } catch (error) {
        this.inProgress = false;
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t('GENERAL.ERROR.GIFT_PURCHASES_UPDATE_FAILED'),
          duration: -1, // stay ON
        });
        return;
      }
    },
    downloadInvoice(data) {},
  },
});
